import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { clearSpaceContentCountsAction, contentCountsRequest } from '~src/app/actions/spaces/ContentCountsActions';

import { PublishedConnectionTableCountsRequestAction } from '../actions/PublishedConnectionTableCountsRequestAction';

export function* handlePublishedConnectionTableCountsRequest(action: PublishedConnectionTableCountsRequestAction): SagaIterator {
  yield put(clearSpaceContentCountsAction(action.spaceType));
  yield put(contentCountsRequest());
}
